<template>

  <div class="card-background">
      <div class="columns">

      <TournamentMenu :tournament="tournament" />

      <div class="column is-four-fifths-desktop is-four-fifths-tablet">

        <div v-if="tournament" class="tournament-teams-container">
          <h2 class="has-text-weight-bold has-text-left is-size-3" style="margin-bottom: 30px;">{{ tournament.name }} - Teams</h2>

          <b-table :data="tournament.teams" :columns="tableColumns" v-if="tournament" @click="teamClick"></b-table>


          <div class="has-text-right" style="margin-top: 25px;">
            <router-link :to="'/tournaments/' + tournament.id + '/teams/add'" class="button is-danger is-medium">Add team</router-link>
          </div>
        </div>

        <div v-if="!tournament">
          <b-loading />
        </div>


      </div>

    </div>
  </div>
</template>

<script>
  import TournamentMenu from '../components/TournamentMenu.vue';
  import TournamentDataMixin from '../mixins/TournamentDataMixin.js';

export default {
  mixins: [ TournamentDataMixin ],

  data: () => {
    return {
      tableColumns: [
        {field: 'id', label: '#'},
        {field: 'shortName', label: 'Short identifier'},
        {field: 'name', label: 'Name'},
        {field: 'coach', label: 'Coach'}
      ]
    }
  },
  computed: {
    tournaments: function(){ return this.$store.state.tournaments; }
  },

  methods: {
    teamClick(team) {
      let tournamentId = this.$route.params.id;
      this.$router.push('/tournaments/' + tournamentId + '/teams/' + team.id + '/edit');
    }
  },

  components: { TournamentMenu },
  name: 'tournament-teams'
}
</script>



<style>
  div.tournament-teams-container div.b-table tbody tr {
    cursor: pointer;
  }
</style>
